{
  "name": "howden-login",
  "version": "6.5.2",
  "title": "Howden Login",
  "languages": [
    "es",
    "en"
  ],
  "copyright": "Copyright 2015-2026 | Howden Iberia | Todos los derechos reservados",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-DevelopmentHowdenGroup": "ng build --configuration development",
    "build-StagingHowdenGroup": "ng build --configuration staging",
    "build-ProductionHowdenGroup": "ng build --configuration production",
    "build-Production-SchedulerHowdenGroup": "ng build --configuration production",
    "build-DevelopmentHowdenGroupB2C": "ng build --configuration development-b2c",
    "build-StagingHowdenGroupB2C": "ng build --configuration staging-b2c",
    "build-ProductionHowdenGroupB2C": "ng build --configuration production-b2c",
    "build-Production-SchedulerHowdenGroupB2C": "ng build --configuration production-b2c",
    "watch": "ng build --watch",
    "test": "ng test",
    "lint": "eslint ",
    "lint-and-fix": "eslint --fix",
    "i18n-extract": "ng extract-i18n --output-path=src/locale --progress=true"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.21",
    "@angular/compiler": "^21.2.21",
    "@angular/core": "^21.2.21",
    "@angular/forms": "^21.2.21",
    "@angular/material": "^21.2.14",
    "@angular/material-moment-adapter": "^21.2.14",
    "@angular/platform-browser": "^21.2.21",
    "@angular/platform-browser-dynamic": "^21.2.21",
    "@angular/router": "^21.2.21",
    "@azure/msal-angular": "^4.0.17",
    "@azure/msal-browser": "^4.19.0",
    "@howdeniberia/core-front": "^21.0.1",
    "moment": "^2.30.1",
    "ngx-cookie-service": "^21.3.1",
    "ngx-toastr": "~20.0.5",
    "rxjs": "~7.8.1",
    "tslib": "^2.6.3",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/core": "^21.2.19",
    "@angular-devkit/schematics": "^21.2.19",
    "@angular/build": "^21.2.19",
    "@angular/cli": "^21.2.19",
    "@angular/compiler-cli": "^21.2.21",
    "@angular/localize": "^21.2.21",
    "@eslint/js": "^9.10.0",
    "@schematics/angular": "^21.2.19",
    "@types/eslint__js": "^8.42.3",
    "@types/jasmine": "^6.0.0",
    "@types/node": "^22.19.7",
    "angular-eslint": "^20.7.0",
    "eslint": "^9.28.0",
    "jasmine-core": "^6.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "ng-packagr": "^21.2.6",
    "typescript": "~5.9.3",
    "typescript-eslint": "8.65"
  }
}
